import { WIDGET_STYLE_FALLBACKS } from './widget-style-defaults'

const PX_KEYS = [
  'width',
  'height',
  'margin',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
  'padding',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft'
] as const

function pxValue(value: unknown): string | undefined {
  if (value === null || value === undefined || value === '') return undefined
  const num = Number(value)
  if (!Number.isFinite(num)) return undefined
  return `${num}px`
}

export function widgetBoxStyle(style?: Record<string, unknown> | null): Record<string, string> {
  const source = style ?? {}
  const out: Record<string, string> = {}
  for (const key of PX_KEYS) {
    const px = pxValue(source[key])
    if (px) out[key] = px
  }
  const radius = pxValue(source.radius ?? source.borderRadius ?? WIDGET_STYLE_FALLBACKS.radius)
  if (radius) out.borderRadius = radius
  if (source.backgroundColor) out.backgroundColor = String(source.backgroundColor)
  return out
}

export function widgetHasFixedSize(style?: Record<string, unknown> | null, key: 'width' | 'height' = 'height'): boolean {
  const num = Number(style?.[key])
  return Number.isFinite(num) && num > 0
}

export function widgetHasFixedHeight(style?: Record<string, unknown> | null): boolean {
  return widgetHasFixedSize(style, 'height')
}
